export const seccionesMX = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : true,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": true,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesMedir3MX = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : true,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];
export const seccionesMedir3CAYC = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : true,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesMedir3TR = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesMedir3HK_CAYC = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : true,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": true,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesPulsecheck3 = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : false ,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : false,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": false,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];
export const seccionesPulsecheck3Turquia = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : false ,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": false,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];
export const seccionesFocusArea3 = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : false ,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesCAYC = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : true,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": true,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesHK = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesHKPlantillaRumano = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": true,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesFL = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 0,
    "estatus" : false,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesSGP = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 0,
    "estatus" : false,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesTR_1 = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesTR_2 = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesTR_3 = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

///// Plantilla TR_EN_DE_PT_ZH1_TI_+_EVP
export const seccionesTRPlantilla = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 0,
    "estatus": false,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

/////// SECCIONES MEDIR NUEVOS

export const seccionesMedir_1 = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : true,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  }
];
export const seccionesMedir_Generico = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : true,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": true,
    "typeSection": 6
  }
];

export const seccionesIzzi = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": true,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 0,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesBrasil = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": true,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : true,
    "typeSection": 7
  }
];

export const seccionesGCTI = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": false,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesGCTI_2023_ESP_ING_V1 = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesSpain = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 0,
    "estatus": false,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 0,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 0,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesCerAmco = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 0,
    "estatus": false,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 0,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 0,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesCerTrabajoDigno = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 0,
    "estatus" : false,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 0,
    "estatus": false,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 0,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 0,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesCerPrimerTrabajo = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : true,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 0,
    "estatus" : false,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 0,
    "estatus": false,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 0,
    "estatus": false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 0,
    "estatus" : false,
    "typeSection": 7
  }
];

export const seccionesCerPla = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false,
    "typeSection": 1
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 0,
    "estatus" : false,
    "typeSection": 2
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false,
    "typeSection": 3
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 0,
    "estatus" : false,
    "typeSection": 4
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 0,
    "estatus" : false,
    "typeSection": 5
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 0,
    "estatus" : false,
    "typeSection": 6
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 0,
    "estatus" : false,
    "typeSection": 7
  }
];
